import * as checkConstant from '@/api/biz/outbound/checkConstant';
import { i18n } from '@/api/i18n'

export const getPayTypeValue = (payType) => {
  //支付方式
  let mode;
  switch (payType) {
    case 1:
      mode = i18n.t(checkConstant.ONLINE);
      break;
    case 2:
      mode = i18n.t(checkConstant.COD);
      break;
    case 3:
      mode = i18n.t(checkConstant.Transfer);
      break;
    case 4:
      mode = i18n.t(checkConstant.IOU);
      break;
    case 5:
      mode = i18n.t(checkConstant.MF);
      break;
    case 6:
      mode = i18n.t(checkConstant.MF_PHOTO);
      break;
    case 7:
      mode = i18n.t(checkConstant.INSTALLMENT);
      break;
    case 8:
      mode = i18n.t(checkConstant.POP);
      break;
    case 9:
      mode = i18n.t(checkConstant.TCK);
      break;
    case 10:
      mode = i18n.t(checkConstant.O2O);
      break;
    case 11:
      mode = i18n.t(checkConstant.PLANE);
      break;
    case 12:
      mode = i18n.t(checkConstant.VSP_1);
      break;
    case 13:
      mode = i18n.t(checkConstant.VSP_2);
      break;
    case 14:
      mode = i18n.t(checkConstant.HOTEL);
      break;
    default:
      mode = "";
      break;
  }
  return mode;
}

export const getPayTypeValueNew = (systemId, payType) => {
  //支付方式
  let mode;
  if (checkConstant.SYSTEMID_EPT == systemId) {
    switch (payType) {
      case 0:
        mode = "COD";
        break;
      case 1:
      case 100:
        mode = "Online";
        break;
      case 2:
        mode = "Delivery";
        break;
      case 3:
        mode = "Transfer";
        break;
      case 4:
        mode = "Qiwi";
        break;
      case 5:
        mode = "Adyen";
        break;
      case 7:
        mode = "Ebanx";
        break;
      default:
        mode = "";
        break;
    }
  }
  else {
    switch (payType)
    {
      case 1:
        mode = i18n.t(checkConstant.ONLINE);
        break;
      case 2:
        mode = i18n.t(checkConstant.COD);
        break;
      case 3:
        mode = i18n.t(checkConstant.Transfer);
        break;
      case 4:
        mode = i18n.t(checkConstant.IOU);
        break;
      case 5:
        mode = i18n.t(checkConstant.MF);
        break;
      case 6:
        mode = i18n.t(checkConstant.MF_PHOTO);
        break;
      case 7:
        mode = i18n.t(checkConstant.INSTALLMENT);
        break;
      case 8:
        mode = i18n.t(checkConstant.POP);
        break;
      case 9:
        mode = i18n.t(checkConstant.TCK);
        break;
      case 10:
        mode = i18n.t(checkConstant.O2O);
        break;
      case 11:
        mode = i18n.t(checkConstant.PLANE);
        break;
      case 12:
        mode = i18n.t(checkConstant.VSP_1);
        break;
      case 13:
        mode = i18n.t(checkConstant.VSP_2);
        break;
      case 14:
        mode = i18n.t(checkConstant.HOTEL);
        break;
      default:
        mode = "";
        break;
    }
  }
  return mode;
}

